import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import AsModalWithContext from '../../../../components/as-modal/with-context';
import { AutomationRulesContext } from '../context';
import { AutomationRule } from '../props';
import { useContextTypes } from 'ui-components/hooks/use-context-types';

import { modalStates } from '../constants/modal-states-constants';
import DeleteModal from './delete-rule/';
import ReprocessModal from './reprocess/';

const AutomationRulesModalManager = () => {
  useContextTypes('AutomationRulesModalManager', AutomationRulesContext, {
    modalState: PropTypes.oneOf(Object.keys(modalStates)).isRequired,
    selectedRule: AutomationRule,
  });

  const { modalState, selectedRule = {} } = useContext(AutomationRulesContext);
  return (
    <>
      {modalState === modalStates.openDelete && !!selectedRule && (
        <AsModalWithContext Context={AutomationRulesContext}>
          <DeleteModal />
        </AsModalWithContext>
      )}
      {modalState === modalStates.openReprocess && (
        <AsModalWithContext Context={AutomationRulesContext}>
          <ReprocessModal />
        </AsModalWithContext>
      )}
    </>
  );
};

export default AutomationRulesModalManager;
